import React from 'react';
import './Appreciate.css';
import Background from './Background';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';

//추가기능을 제공하는 모듈 (Autoplay는 별도 css없어도 적용됨?)
import SwiperCore, { Navigation, Autoplay, Pagination } from 'swiper';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';

const Appreciate = () => {
  //추가기능을 제공하는 모듈
  SwiperCore.use([Navigation, Autoplay, Pagination]);

  return (
    <div className="Appreciate">
      <Background></Background>

      <Swiper
        className="Appreciate_Modal"
        spaceBetween={300}
        slidesPerView={1}
        onSlideChange={() => console.log('slide change')}
        onSwiper={(swiper) => console.log(swiper)}
        navigation={true}
        // autoplay={{ delay: 10000 }}
        pagination={{ clickable: true }}
        loop={true}
      >
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(1).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(2).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(3).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(4).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(5).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(6).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(7).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(8).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(9).jpg" alt="444" />
        </SwiperSlide>
        <SwiperSlide className="SwiperSlide">
          <img className="art_modal" src="images/작품(10).jpg" alt="444" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Appreciate;
